import { apple, facebook, insta, soundcloud, spotify, tiktok, youtube } from "../assets";

/**
 * The row of platform icons along the bottom of every page. Each page
 * positions `.social-icon` itself — the original used a different top offset
 * (and fixed vs. absolute) per page.
 *
 * The hrefs are stored canonically, without the share-sheet tracking that comes
 * attached when a link is copied out of a phone app (`utm_*`, Spotify's `si=`,
 * TikTok's `is_from_webapp` / `sender_web_id`). Those identify the browser
 * session the link was collected from, and none of them are needed to reach the
 * profile. `SocialIcons.test.tsx` fails if one is pasted back in.
 */
export const ICONS = [
  { id: "icon-tiktok", src: tiktok, alt: "TikTok", href: "https://www.tiktok.com/@hernameisriver" },
  {
    id: "icon-insta",
    src: insta,
    alt: "Instagram",
    href: "https://www.instagram.com/hernameisriver",
  },
  {
    id: "icon-spotify",
    src: spotify,
    alt: "Spotify",
    href: "https://open.spotify.com/artist/4RVtMjhWZC6B9k6PvqorqV",
  },
  {
    id: "icon-apple",
    src: apple,
    alt: "Apple Music",
    // Pinned to the Swedish storefront; Apple redirects a visitor to their own.
    href: "https://music.apple.com/se/artist/river/1363074964",
  },
  {
    id: "icon-facebook",
    src: facebook,
    alt: "Facebook",
    href: "https://www.facebook.com/hernameisRiver",
  },
  {
    id: "icon-youtube",
    src: youtube,
    alt: "YouTube",
    href: "https://www.youtube.com/@hernameisriver",
  },
  {
    id: "icon-soundcloud",
    src: soundcloud,
    alt: "SoundCloud",
    href: "https://soundcloud.com/riverbrtejdm",
  },
];

export function SocialIcons() {
  return (
    // `.social-row` is `display: contents` (global.css), so on every width this
    // site already shipped the wrapper has no box and the icons position
    // against `.bg-wrapper` exactly as the bare siblings did. Ticket 001 turns
    // it into a real flex row on a phone, where the in-canvas row is 12 px
    // icons 31 px apart. See src/mobile/layout.css.
    <div className="social-row">
      {ICONS.map(({ id, src, alt, href }) => (
        // The id and both classes live on the anchor, not the image: all four
        // page stylesheets position by `#icon-*` and size by `.social-icon`, so
        // moving the identity keeps them working untouched. `a.social-icon` in
        // global.css restores the block layout an inline anchor would lose.
        <a
          key={id}
          id={id}
          className="social-icon interactive"
          href={href}
          // Leaving the site tears down the persistent background audio, so
          // every one of these opens in a new tab. `noopener` is required with
          // `_blank` regardless.
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={src} alt={alt} />
        </a>
      ))}
    </div>
  );
}
